import { withTiming, Easing, SharedValue, runOnJS } from 'react-native-reanimated'
import { TOAST_CONSTANTS } from './constants'

const { ANIMATION_DURATION, POSITION } = TOAST_CONSTANTS

export const createDismissAnimation = (
  translateY: SharedValue<number>,
  opacity: SharedValue<number>,
  onComplete: () => void
) => {
  'worklet'
  translateY.value = withTiming(
    POSITION.HIDDEN,
    { duration: ANIMATION_DURATION.EXIT },
    (finished) => {
      if (finished) {
        runOnJS(onComplete)()
      }
    }
  )
  opacity.value = withTiming(0, { duration: ANIMATION_DURATION.EXIT })
}

export const createEntryAnimation = (
  translateY: SharedValue<number>,
  opacity: SharedValue<number>
) => {
  'worklet'
  translateY.value = withTiming(POSITION.VISIBLE, {
    duration: ANIMATION_DURATION.ENTRY,
    easing: Easing.out(Easing.ease),
  })
  opacity.value = withTiming(1, { duration: ANIMATION_DURATION.ENTRY })
}

export const createBounceAnimation = (translateY: SharedValue<number>) => {
  'worklet'
  translateY.value = withTiming(POSITION.VISIBLE, { duration: ANIMATION_DURATION.BOUNCE })
}
